import type { FC, ReactNode } from "react";
import styled from "@emotion/styled";
import { colors, fonts } from "../design-tokens";

type AnswerSectionHeadingProps = {
  children: ReactNode;
};

const Heading = styled.h3`
  font-size: 26px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  ${fonts.headingFont};
  color: ${colors.text};
  margin: 0;
`;

export const AnswerSectionHeading: FC<AnswerSectionHeadingProps> = ({ children }) => {
  return <Heading>{children}</Heading>;
};
